/* eslint-disable no-underscore-dangle */

import React from 'react'
import ReactHtmlParser from 'react-html-parser'

import { MarketingTagProps } from '../MarketingTag'

export type AnalystItemProps = {
  firstName: string
  lastName: string
  type: string
}

export type EndorsementProps = {
  agency: string
  status: string
}

export type DisclosureProps = {
  regulatoryAgency: string
  status: string
  postBrexitRegAgency: string
}

export type EntityDetailsItemProps = {
  country: MarketingTagProps
  sectors: MarketingTagProps[]
  analysts: AnalystItemProps[]
  manager: MarketingTagProps
  disclosures: DisclosureProps[]
  solicitationTypeDescription: string
}

export type EntityDetailsCell = {
  cellProps: any
  isUspf?: boolean
}
/* eslint no-unused-expressions: [2, { allowShortCircuit: true }] */
const sectorFilter = (sectors: MarketingTagProps[], filter: string) => {
  let dataAvailable = false
  sectors &&
    sectors.forEach((sector) => {
      if (
        !dataAvailable &&
        sector.name &&
        sector.name.toLowerCase().includes(filter)
      ) {
        dataAvailable = true
      }
    })
  return dataAvailable
}

const analystsFilter = (analysts: AnalystItemProps[], filter: string) => {
  let dataAvailable = false
  analysts &&
    analysts.forEach((analyst) => {
      if (
        (!dataAvailable &&
          analyst.firstName &&
          analyst.firstName.toLowerCase().includes(filter)) ||
        (analyst.lastName && analyst.lastName.toLowerCase().includes(filter)) ||
        (analyst.firstName &&
          analyst.lastName &&
          `${analyst.firstName} ${analyst.lastName}`
            .toLowerCase()
            .includes(filter))
      ) {
        dataAvailable = true
      }
    })
  return dataAvailable
}
const disclosuresFilter = (disclosures: DisclosureProps[], filter: string) => {
  let dataAvailable = false
  disclosures &&
    disclosures.forEach((disclosure) => {
      if (
        (!dataAvailable &&
          disclosure.regulatoryAgency &&
          disclosure.regulatoryAgency.toLowerCase().includes(filter)) ||
        (disclosure.status &&
          disclosure.status.toLowerCase().includes(filter)) ||
        (disclosure.postBrexitRegAgency &&
          disclosure.postBrexitRegAgency.toLowerCase().includes(filter)) ||
        (disclosure.regulatoryAgency &&
          disclosure.status &&
          `${disclosure.regulatoryAgency} ${disclosure.status};`
            .toLowerCase()
            .includes(filter))
      ) {
        dataAvailable = true
      }
    })
  return dataAvailable
}
export const entityDetailsFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const {
    country,
    sectors,
    manager,
    analysts,
    disclosures,
    solicitationTypeDescription
  }: EntityDetailsItemProps = data._original

  let result = false
  const sectorDataAvailable = sectorFilter(sectors, filter)
  const analystDataAvailable = analystsFilter(analysts, filter)
  const disclosuresDataAvailable = disclosuresFilter(disclosures, filter)

  if (
    (country && country.name && country.name.toLowerCase().includes(filter)) ||
    sectorDataAvailable ||
    (manager && manager.name && manager.name.toLowerCase().includes(filter)) ||
    analystDataAvailable ||
    disclosuresDataAvailable ||
    (solicitationTypeDescription &&
      solicitationTypeDescription.toLowerCase().includes(filter))
  ) {
    result = true
  }

  return result
}

const AnalystDetails = ({ analysts, manager }: EntityDetailsItemProps) => (
  <>
    {analysts && analysts.length && !manager
      ? ReactHtmlParser(`<strong>Analysts:</strong><br />`)
      : null}
    {analysts && analysts.length && !manager
      ? analysts.map((analyst) => {
          let result
          if (analyst.type.toLowerCase().includes('primary')) {
            result = ReactHtmlParser(
              `<strong>Primary - </strong> ${analyst.firstName} ${analyst.lastName}<br />`
            )
          } else if (analyst.type.toLowerCase().includes('secondary')) {
            result = ReactHtmlParser(
              `<strong>Secondary - </strong> ${analyst.firstName} ${analyst.lastName}<br />`
            )
          }

          return result
        })
      : null}
  </>
)
// RWR-4605, Change label of Country in securities and obligations for SF entities - Fixed
// This function returns country label and country name based on sector filter under Entity details.
const getCountry = (
  country: MarketingTagProps,
  isUspf = false,
  sectors?: MarketingTagProps[]
) => {
  const isSFEntity = () => {
    let result = false
    if (sectors && sectors.length) {
      const data = sectors.filter(
        (sector) =>
          sector.name && sector.name.toString() === 'Structured Finance'
      )
      if (data && data.length) {
        result = true
      }
      return result
    }
    return result
  }
  const nonUspfLabel =
    country && country.name && !isUspf && isSFEntity() ? ' of Assets' : ''

  if (country && country.name) {
    return ReactHtmlParser(
      `<strong>Country${nonUspfLabel}: </strong> ${country.name}<br />`
    )
  }
  return null
}
export const EntityDetailsCell = (props: EntityDetailsCell) => {
  const { cellProps, isUspf = false } = props
  const {
    country,
    sectors,
    disclosures,
    solicitationTypeDescription
  }: EntityDetailsItemProps = cellProps.original
  return (
    <>
      {getCountry(country, isUspf, sectors)}
      {sectors && sectors.length
        ? ReactHtmlParser(`<strong>Sectors: </strong>`)
        : null}
      {sectors && sectors.length
        ? sectors.map((sector: any, index) => (index ? '; ' : '') + sector.name)
        : null}{' '}
      <br />
      <AnalystDetails {...cellProps.original} />
      {(disclosures && disclosures.length > 0) || solicitationTypeDescription
        ? ReactHtmlParser(`<strong>Disclosures:</strong>`)
        : null}
      {disclosures && disclosures.length > 0
        ? disclosures.map((disclosuresItem) => {
            let display = ''
            if (disclosuresItem.postBrexitRegAgency) {
              display = ` ${disclosuresItem.postBrexitRegAgency};`
            } else {
              display = ` ${disclosuresItem.regulatoryAgency} ${disclosuresItem.status};`
            }
            return ReactHtmlParser(display)
          })
        : null}
      {solicitationTypeDescription
        ? ReactHtmlParser(` ${solicitationTypeDescription}`)
        : null}
    </>
  )
}
export default EntityDetailsCell
